import { SLAStatusToTagColorMap, SLAStatusToIconColorTokenMap } from '../constants/SLAColorConstants';
/**
 * Tag takes color in the 'use' param. By convention, that param takes color names in lowercase and with dashes
 * between words.
 *
 * This is different from how Icon works, hence the two different helper functions and return types.
 */
export const getSLATagColorFromStatus = slaStatus => SLAStatusToTagColorMap[slaStatus];
export const getSLAIconColorTokenFromStatus = slaStatus => {
  if (!slaStatus) {
    return 'icon-core-subtle';
  }
  return SLAStatusToIconColorTokenMap[slaStatus];
};